// TODO: improve formatting to support all pluggy supported currencies
// https://pluggy.atlassian.net/browse/INT-167
export function formatMoney(value, currencyCode) {
    if (currencyCode === void 0) { currencyCode = 'ARS'; }
    var currencyCode_ = currencyCode !== null && currencyCode !== void 0 ? currencyCode : 'ARS';
    // BRL Symbol not supported atm
    if (currencyCode_ === 'BRL') {
        var formatted = new Intl.NumberFormat('es-AR', {
            style: 'currency',
            currency: 'ARS',
        }).format(value);
        return formatted.replace('$', 'R$');
    }
    try {
        var formattedMoney = new Intl.NumberFormat('es-AR', {
            style: 'currency',
            currency: currencyCode_,
        }).format(value);
        return formattedMoney;
    }
    catch (_a) {
        // not supported currency code
        return currencyCode + " " + value;
    }
}
/**
 * Format percentage number to string, rounded to up to 2 decimal places
 *
 * @param value
 */
export function formatPercentage(value) {
    return Math.round((value + Number.EPSILON) * 100) / 100 + "%";
}
